import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { UserInfoComponent } from '@features/user-management/components/user-info/user-info.component';
import { UpdateUserComponent } from '@features/user-management/components/update-user/update-user.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { UpdateUserProfileRequest, UserResponse } from '@features/user-management/user.model';
import { UserApiService } from '@features/user-management/user.service';
import {SHARED_IMPORTS} from "../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-profile-page',
  imports: [UserInfoComponent, UpdateUserComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './profile.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfilePage {
  private readonly userApiService = inject(UserApiService);

  protected readonly loading = signal(false);
  protected readonly saving = signal(false);
  protected readonly user = signal<UserResponse | null>(null);

  constructor() {
    this.loadProfile();
  }

  protected loadProfile(): void {
    this.loading.set(true);
    this.userApiService.getUserProfile().subscribe({
      next: (user) => {
        this.user.set(user);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }

  protected saveProfile(update: UpdateUserProfileRequest): void {
    this.saving.set(true);
    this.userApiService.updateUserProfile(update).subscribe({
      next: () => {
        this.saving.set(false);
        this.loadProfile();
      },
      error: () => this.saving.set(false),
    });
  }
}